// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 250px;
}

.content-expanded {
  transition: margin-left 0.3s ease;
}

.bg-zikata {
  background-color: #2e005d;
}

:host {
  display: block;
  height: 100%;
}

.d-flex.vh-100 {
  position: relative;
}
.d-flex.vh-100 > div:last-child {
  position: relative;
  z-index: 1;
}

zikatagov-header {
  position: relative;
  z-index: 30;
}

zikatagov-page-header {
  position: relative;
  z-index: 20;
}

.container-fluid {
  background: none !important;
}

main {
  position: relative;
  z-index: 10;
}
main .dropdown-menu,
main [class*=dropdown],
main .card .dropdown-menu {
  z-index: 1000 !important;
}

::ng-deep .bg-light .dropdown-menu.show,
::ng-deep .bg-light .select-dropdown,
::ng-deep .bg-light [role=listbox],
::ng-deep .container-fluid .dropdown-menu.show,
::ng-deep .container-fluid .select-dropdown,
::ng-deep .container-fluid [role=listbox],
::ng-deep .card .dropdown-menu.show,
::ng-deep .card .select-dropdown,
::ng-deep .card [role=listbox],
::ng-deep [class*=dropdown] .dropdown-menu.show,
::ng-deep [class*=dropdown] .select-dropdown,
::ng-deep [class*=dropdown] [role=listbox] {
  z-index: 9999 !important;
  position: absolute !important;
}
::ng-deep select,
::ng-deep .form-select,
::ng-deep [class*=select] {
  position: relative;
  z-index: 100;
}
::ng-deep select + .dropdown-menu,
::ng-deep select ~ .dropdown-menu,
::ng-deep .form-select + .dropdown-menu,
::ng-deep .form-select ~ .dropdown-menu,
::ng-deep [class*=select] + .dropdown-menu,
::ng-deep [class*=select] ~ .dropdown-menu {
  z-index: 9999 !important;
}`, "",{"version":3,"sources":["webpack://./apps/clients-portal/src/app/layouts/default-layout/default-layout.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAIA;EACE,cAAA;EACA,YAAA;AADF;;AAKA;EACE,kBAAA;AAFF;AAKE;EACE,kBAAA;EACA,UAAA;AAHJ;;AAQA;EACE,kBAAA;EACA,WAAA;AALF;;AAQA;EACE,kBAAA;EACA,WAAA;AALF;;AAOA;EACE,2BAAA;AAJF;;AAMA;EACE,kBAAA;EACA,WAAA;AAHF;AAME;;;EAGE,wBAAA;AAJJ;;AAgBI;;;;;;;;;;;;EAGE,wBAAA;EACA,6BAAA;AAJN;AASE;;;EAGE,kBAAA;EACA,YAAA;AAPJ;AASI;;;;;;EAEE,wBAAA;AAHN","sourcesContent":[".sidebar {\n  width: 250px;\n}\n\n.content-expanded {\n  transition: margin-left 0.3s ease;\n}\n\n.bg-zikata {\n  background-color: #2e005d;\n}\n// In default-layout.component.scss\n\n// Ensure proper stacking context\n:host {\n  display: block;\n  height: 100%;\n}\n\n// Desktop layout\n.d-flex.vh-100 {\n  position: relative;\n  \n  // Main content area\n  > div:last-child {\n    position: relative;\n    z-index: 1;\n  }\n}\n\n// Fix header stacking\nzikatagov-header {\n  position: relative;\n  z-index: 30; // Higher than page header\n}\n\nzikatagov-page-header {\n  position: relative;\n  z-index: 20; // Lower than main header\n}\n.container-fluid {\n  background: none !important;\n}\nmain {\n  position: relative;\n  z-index: 10;\n  \n  // But ensure dropdowns from main content appear above headers\n  .dropdown-menu,\n  [class*=\"dropdown\"],\n  .card .dropdown-menu {\n    z-index: 1000 !important; // Higher than both headers\n  }\n}\n\n// Critical fix for dropdowns in the main content\n::ng-deep {\n  // Any dropdown or select element in the main content\n  .bg-light,\n  .container-fluid,\n  .card,\n  [class*=\"dropdown\"] {\n    // Ensure dropdown menus are not clipped\n    .dropdown-menu.show,\n    .select-dropdown,\n    [role=\"listbox\"] {\n      z-index: 9999 !important;\n      position: absolute !important;\n    }\n  }\n  \n  // Fix for the \"Select a Sender ID\" specifically\n  select,\n  .form-select,\n  [class*=\"select\"] {\n    position: relative;\n    z-index: 100;\n    \n    + .dropdown-menu,\n    ~ .dropdown-menu {\n      z-index: 9999 !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
